// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"df4eee25","48":"00d05f4f","213":"fd0a99cb","281":"dfaa18cf","325":"179bb061","845":"130731da","995":"692837c6"}[chunkId] + ".chunk.js";
};